import React from 'react';

export default function BottomLeftCorner() {
  return (
    <svg
      style={{ display: 'block' }}
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0 22L0 23H1H23V22H1L1 0H0L0 22Z" fill="white" />
    </svg>
  );
}
